import React, { createContext, useReducer, useState, useContext } from "react";
import { AuthState, AuthAction, AuthContextValue } from "../types/auth";

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined
);

export const useAuthContext = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error(
      "useAuthContext must be used inside an AuthContextProvider"
    );
  }
  return context;
};

export const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case "LOGIN": {
      return { user: action.payload };
    }
    case "LOGOUT": {
      return { user: null };
    }
    default:
      return state;
  }
};

interface AuthContextProviderProps {
  children: React.ReactNode;
}

export const AuthContextProvider: React.FC<AuthContextProviderProps> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
  });
  const [auth, setAuth] = useState<Record<string, unknown>>({});

  return (
    <AuthContext.Provider value={{ auth, setAuth, state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
